const lessonObjectivesUrl = '/lesson-objectives';

export default lessonObjectivesUrl;
